import type { CustomFieldDefinition } from './index';
import { FieldsetCustomFieldDefinition } from './index';

type CustomFieldPath = {
  path: string;
  description: string;
};

export const getFieldPaths = (field: CustomFieldDefinition) => {
  const fieldIdentifier = field.identifier;

  const paths: string[] = [fieldIdentifier];

  if (field instanceof FieldsetCustomFieldDefinition) {
    for (const childField of field.children) {
      paths.push(
        ...getFieldPaths(childField).map((p) => `${field.identifier}.${p}`)
      );
    }
  }

  return paths;
};

export const getTerminalFieldPathsWithDescription = (
  field: CustomFieldDefinition
) => {
  const fieldIdentifier = field.identifier;

  const paths: CustomFieldPath[] = [];

  if (field instanceof FieldsetCustomFieldDefinition) {
    for (const childField of field.children) {
      paths.push(
        ...getTerminalFieldPathsWithDescription(childField).map((p) => ({
          description: `${field.label} - ${p.description}`,
          path: `${field.identifier}.${p.path}`,
        }))
      );
    }
  } else {
    paths.push({
      path: fieldIdentifier,
      description: field.label,
    });
  }

  return paths;
};
